/* eslint-disable sonarjs/no-duplicate-string */
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import { hasVisibilityLightAccess } from '@/helpers/hasVisibilityLightAccess';
import store from '@/store';
import { SalesforceHgInventoryFocusGroupEnum } from '@/types-agency';

export function isUnsupportedBrowser(): boolean {
  return /^.*((MSIE(?!\s11))+|(Trident\/[0-6]+)).*/i.test(navigator.userAgent);
}

export const vPlusRouteGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const isPremiumAgency = store.getters.getActiveAgency?.isPremiumAgency ?? false;
  const isVisibilityLight = hasVisibilityLightAccess(store.getters.getActiveProducts);
  const isAgencyInBuyDomain =
    store.getters['agencyProfile/getAgencyProfile']?.hgInventoryFocusGroup ===
      SalesforceHgInventoryFocusGroupEnum.MixedFocus ||
    store.getters['agencyProfile/getAgencyProfile']?.hgInventoryFocusGroup ===
      SalesforceHgInventoryFocusGroupEnum.Sale;

  if (!isPremiumAgency && !isVisibilityLight && !isAgencyInBuyDomain) {
    const locale = from.params.locale || to.params.locale;
    const path = `/${locale}/ubm/not-found`;
    return next({ path });
  }
  next();
};

export const referenceListingsGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const isPremiumAgency = store.getters.getActiveAgency?.isPremiumAgency ?? false;
  const hasGoldPackage = store.getters.getIsGoldPackage;
  const hasSilverPackage = store.getters.getIsSilverPackage;
  const hasWelcomePackage = store.getters.getIsWelcomePackage;
  const isVisibilityLight = hasVisibilityLightAccess(store.getters.getActiveProducts);
  const hasAccess =
    isPremiumAgency || hasGoldPackage || hasSilverPackage || hasWelcomePackage || isVisibilityLight;

  if (!hasAccess) {
    const locale = from.params.locale || to.params.locale;
    const path = `/${locale}/ubm/not-found`;
    return next({ path });
  }
  next();
};

export const packageOverviewGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const isBronzePackage = store.getters.getIsBronzePackage;
  const hasSilverPackage = store.getters.getIsSilverPackage;
  const hasGoldPackage = store.getters.getIsGoldPackage;
  const hasAccess = isBronzePackage || hasSilverPackage || hasGoldPackage;

  if (!hasAccess) {
    const locale = from.params.locale || to.params.locale;
    const path = `/${locale}/ubm/not-found`;
    return next({ path });
  }
  next();
};
